export default __webpack_public_path__ + "static/media/mobile_tc1_Hk.f7d59bbc.webp";